module.exports = __webpack_public_path__ + "img/pr.a8d13a30.svg";